import * as React from "react";
import type { SVGProps } from "react";
const SvgScreenshotIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="screenshot_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M412.16 128a128 128 0 0 0-111.104 64.512l-48.47 84.821h-39.253a128 128 0 0 0-128 128V768a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V405.333a128 128 0 0 0-128-128h-39.254l-48.469-84.821A128 128 0 0 0 611.84 128H412.203zm-37.035 106.837a42.667 42.667 0 0 1 37.078-21.504h199.594a42.667 42.667 0 0 1 37.078 21.504l60.757 106.326a42.667 42.667 0 0 0 37.035 21.504h64a42.667 42.667 0 0 1 42.666 42.666V768a42.667 42.667 0 0 1-42.666 42.667H213.333A42.667 42.667 0 0 1 170.667 768V405.333a42.667 42.667 0 0 1 42.666-42.666h64a42.667 42.667 0 0 0 37.035-21.504l60.757-106.326zM512 768a213.333 213.333 0 1 0 0-426.667A213.333 213.333 0 0 0 512 768zm128-213.333a128 128 0 1 1-256 0 128 128 0 0 1 256 0z"
    />
  </svg>
);
export default SvgScreenshotIcon;
